module.exports = __webpack_public_path__ + "static/img/dd-banner-02.d33a104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-02.png
// module id = CEEY
// module chunks = 1